import configuration from 'services/Configuration/reducer/initialState'
import app from 'components/App/reducer/initialState'
import items from 'components/Items/reducer/initialState'
import emailSubscriptionForm from 'components/EmailSubscriptionForm/reducer/initialState'
import formItems from 'components/FormItems/reducer/initialState'
import appCaptcha from 'components/AppCaptcha/reducer/initialState'
import itemsCreationForm from 'components/ItemsCreationForm/reducer/initialState'
import wrapper from 'services/Wrapper/reducer/initialState'


export default {
    configuration,
    app,
    items,
    emailSubscriptionForm,
    formItems,
    itemsCreationForm,
    appCaptcha,
    wrapper
}
